import { storyblokInit as a } from "./storyblok-js.mjs";
import { RichTextResolver as g, RichTextSchema as C, apiPlugin as d, loadStoryblokBridge as S, registerStoryblokBridge as h, renderRichText as x, storyblokEditable as F, registerStoryblokBridge as A } from "./storyblok-js.mjs";
import { default as R } from "./server-component.mjs";
let e = null;
const r = /* @__PURE__ */ new Map();
let n = !1, l = null;
globalThis.storyCache = /* @__PURE__ */ new Map();
const i = () => (e || console.error(
  "You can't use getStoryblokApi if you're not loading apiPlugin."
), e), c = (o) => (Object.entries(o).forEach(([t, s]) => {
  r.set(t, s);
}), r), k = (o) => r.has(o) ? r.get(o) : (console.error(`Component ${o} doesn't exist.`), !1), m = () => n, p = () => l, u = (o = {}) => {
  if (e)
    return () => e;
  const { storyblokApi: t } = a(o);
  return e = t, o.components && c(o.components), n = o.enableFallbackComponent, l = o.customFallbackComponent, () => t;
};
export {
  g as RichTextResolver,
  C as RichTextSchema,
  R as StoryblokServerComponent,
  d as apiPlugin,
  k as getComponent,
  p as getCustomFallbackComponent,
  m as getEnableFallbackComponent,
  i as getStoryblokApi,
  S as loadStoryblokBridge,
  h as registerStoryblokBridge,
  x as renderRichText,
  c as setComponents,
  F as storyblokEditable,
  u as storyblokInit,
  i as useStoryblokApi,
  A as useStoryblokBridge
};
